import { ClientSideTable } from 'Presentation/Components/Table'
import { TableContext } from '../../../../../Context/Table'
import { useContext, useEffect } from 'react'
// import { KTSVG } from '_metronic/helpers'

interface Props {
  onClickAdd: () => void
  data: any[]
  columns: any[]
}

const AssetRequest: React.FC<Props> = ({ onClickAdd, columns, data }) => {
  

  
  return (
    <div className='card'>
      <div className='card-header'>
        <div className='card-title'></div>
        <div className='card-toolbar'>
          {/* <button className='btn btn-sm btn-primary' onClick={onClickAdd}>
            <KTSVG
              path='/media/icons/duotune/arrows/arr017.svg'
              svgClassName='svg-icon-1 svg-primary'
            />
            <span>เพิ่มทรัพยากร</span>
          </button> */}
        </div>
      </div>

      <div className='card-body px-0'>
        <ClientSideTable isGrey pagination columns={columns} data={data} items_per_page={10} sorting={[{ id:"receivedToProjectAt", desc: true }]} />
      </div>
    </div>
  )
}

export default AssetRequest
